module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "history"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "history-table"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('table', {
    staticClass: "table"
  }, [_vm._m(1), _vm._v(" "), _c('tbody', _vm._l((_vm.history), function(marathon, index) {
    return _c('tr', {
      key: ("marathon." + index)
    }, [_c('td', [_vm._v(_vm._s(marathon.name))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(marathon.charity))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("localDate")(marathon.start_date)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("localDate")(marathon.end_date)))]), _vm._v(" "), _c('td', {
      staticClass: "right"
    }, [_vm._v(_vm._s(_vm._f("durationToHours")(marathon.duration)))]), _vm._v(" "), _c('td', {
      staticClass: "right"
    }, [_vm._v(_vm._s(marathon.attendees))]), _vm._v(" "), _c('td', {
      staticClass: "right"
    }, [_vm._v("$" + _vm._s(marathon.donation_total.toLocaleString('en-US', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    })))]), _vm._v(" "), _c('td', [_c('a', {
      attrs: {
        "href": marathon.playlist,
        "target": "_blank"
      }
    }, [_vm._v("Watch")])])])
  }), 0)])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "section"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('h1', {
    staticClass: "title is-spaced"
  }, [_vm._v("History")]), _vm._v(" "), _c('h2', {
    staticClass: "subtitle"
  }, [_vm._v("Missed a marathon or want to see what we've done in the past? Check out past marathons below")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("Marathon")]), _vm._v(" "), _c('th', [_vm._v("Charity")]), _vm._v(" "), _c('th', [_vm._v("Start Date")]), _vm._v(" "), _c('th', [_vm._v("End Date")]), _vm._v(" "), _c('th', {
    staticClass: "right"
  }, [_vm._v("Duration")]), _vm._v(" "), _c('th', {
    staticClass: "right"
  }, [_vm._v("Attendees")]), _vm._v(" "), _c('th', {
    staticClass: "right"
  }, [_vm._v("Donation Total")]), _vm._v(" "), _c('th', [_vm._v("Playlist")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-08b0cf59","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/HistoryView/index.vue
// module id = 231
// module chunks = 1